<!-- Persistent indicator tab — flush left of sidebar (positioned by layout parent) -->
@if (hasAlerts()) {
  <div class="flex w-max">
    <button
      type="button"
      (click)="togglePopup()"
      class="relative inline-flex items-center gap-1.5 px-2 py-1.5 text-xs cursor-pointer border border-base-300 border-l-0 rounded-r bg-base-200 hover:bg-base-300 transition-colors"
      title="System Alerts"
    >
      <!-- Inline icon (currentColor) so it themes cleanly; the raster SVG had a
           white background fill that rendered as a light box on the dark tab. -->
      <svg
        class="w-4 h-4 text-warning"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
      @if (hasUndismissed()) {
        <span class="w-2 h-2 bg-red-500 rounded-full"></span>
      }
    </button>
  </div>
}

<!-- Floating alert popup (top-right, below navbar) -->
@if (hasUndismissed() && !popupMinimized()) {
  <div class="fixed top-20 right-6 z-[100] w-[420px] max-w-[calc(100vw-2rem)] flex flex-col gap-2">
    @for (alert of undismissedAlerts(); track alert.id) {
      <div class="border-l-4 rounded-lg shadow-lg p-4 animate-slide-in" [ngClass]="getAlertClasses(alert.status)">
        <div class="flex items-start gap-3">
          <img [src]="getIconPath(alert.status)" alt="" class="w-5 h-5 mt-0.5 flex-shrink-0" />
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-sm">{{ alert.title }}</div>
            <!-- details_html is rendered from Markdown and sanitized on the backend (nh3),
                 and sanitized again by Angular on bind. -->
            <div class="text-sm mt-1 markdown-content" [innerHTML]="alert.details_html"></div>
          </div>
          <button
            type="button"
            (click)="dismiss(alert.id)"
            class="tooltip tooltip-left flex-shrink-0 p-1 rounded hover:bg-black/10 transition-colors cursor-pointer before:max-w-[13rem] before:whitespace-normal before:text-left before:text-white before:text-xs before:font-normal"
            data-tip="Hide for now. Comes back the next time you sign in."
            aria-label="Hide for now. Comes back the next time you sign in."
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <!-- Acknowledge is the durable action: the close button only hides the
             alert for this session, this stops it returning on future sign ins.
             Both tooltips are phrased in parallel so the contrast is obvious. -->
        <div class="flex justify-end mt-2">
          <button
            type="button"
            (click)="acknowledge(alert.id)"
            [disabled]="isAcknowledging(alert.id)"
            class="tooltip tooltip-left inline-flex items-center gap-1 px-2 py-0.5 text-[11px] font-semibold rounded border bg-transparent transition-colors cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed before:max-w-[13rem] before:whitespace-normal before:text-left before:text-white before:text-xs before:font-normal"
            [ngClass]="getAcknowledgeClasses(alert.status)"
            data-tip="Dismiss the alert permanently. It will not return on future sign ins."
          >
            @if (isAcknowledging(alert.id)) {
              <span class="loading loading-spinner loading-xs"></span>
            }
            Acknowledge
          </button>
        </div>
      </div>
    }
  </div>
}
